import Orders from './components/Orders';

export default Orders;
